import { OrderFilters } from '@app/healthcheck/ordersTable/types';
import { healthCheckExportCSVUrl } from '@app/definition/API';

const generateLinkForDownloadCSVFile = (filters: OrderFilters): string => {
  let url = healthCheckExportCSVUrl.replace('%status%', filters.ordersState);
  if (filters.searchText) url = `${url}&search=${filters.searchText}`;
  if (filters.endDate) url = `${url}&date=${filters.endDate}`;
  return url;
};

export default generateLinkForDownloadCSVFile;
